"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditPhoneNumberPopupWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var reactstrap_1 = require("reactstrap");
var journey_model_1 = require("@athena-portal/journey-model");
var commonFunctions_1 = require("../../../commonFunctions");
var services_1 = require("@falcon/services");
var EditPhoneNumberPopupWidget = exports.EditPhoneNumberPopupWidget = /** @class */ (function (_super) {
    __extends(EditPhoneNumberPopupWidget, _super);
    function EditPhoneNumberPopupWidget(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.navigateToNextPage = function () {
            var _a;
            _this.props.engine.setJourneyState((_a = {}, _a["showPhoneNumberPopup"] = false, _a));
            _this.props.engine.navigate(_this.navigateToPage, true);
        };
        _this.renderPopup = function () {
            var closeBtn = React.createElement("button", { className: "btn-close", onClick: _this.toggleModal });
            var journeyState = _this.props.engine.getJourneyState();
            return (React.createElement(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: journeyState["showPhoneNumberPopup"], toggle: _this.toggleModal },
                React.createElement(reactstrap_1.ModalHeader, { toggle: _this.toggleModal, close: closeBtn },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("img", { className: "d-block mr-3 mb-1", src: "/".concat(services_1.resourcesHelper.THEME, "/img/alert-grey-blue.svg"), alt: "Attention icon" }),
                        React.createElement("div", { className: "text-blue-2 font-weight-medium fs-20" }, "Edit your mobile number"))),
                React.createElement(reactstrap_1.ModalBody, { className: "pt-0 overflow-auto" },
                    React.createElement("div", { className: "mb-3" },
                        React.createElement("p", { className: "m-0" }, "The mobile number doesn\u2019t look right..."),
                        React.createElement("p", { className: "m-0" }, "You need to provide us a valid mobile number. We'll only use it to contact you about your cover.")),
                    React.createElement("div", { className: "custom-margin-mobile-cut-sides mr-4 ml-4" },
                        React.createElement("p", null,
                            React.createElement("span", { className: "font-weight-bold" }, "Mobile number")),
                        React.createElement("div", { className: "col-md-7 d-flex p-0" },
                            React.createElement("input", { onChange: _this.handlePhoneNumberChange, onBlur: _this.executeNativeEvent, onFocus: _this.executeNativeEvent, onClick: _this.executeNativeEvent, value: _this.state.phoneNumber, type: "text", id: "phoneNumber", className: "form-control", "aria-label": _this.props.question.label })))),
                React.createElement(reactstrap_1.ModalFooter, { className: "d-block custom-margin-mobile-cut-sides" },
                    React.createElement("button", { type: "button", className: "btn btn-primary ".concat(_this.state.phoneNumberValidated ? "" : "btn-disabled ", " btn-next-arrow-separate width-md-250"), onClick: _this.savePhoneNumberChanges },
                        "Save & continue",
                        React.createElement("img", { className: "arrow-next", alt: "Arrow icon", src: "/img/arrow-next.png" })),
                    React.createElement("button", { type: "button", className: "btn btn-back width-md-250", onClick: _this.toggleModal }, "Cancel"))));
        };
        _this.handlePhoneNumberChange = function (event) {
            event.preventDefault();
            var phoneNumber = event.target.value;
            _this.setState({ phoneNumber: phoneNumber });
            _this.setState({
                phoneNumberValidated: (0, commonFunctions_1.validatePhoneNumber)(phoneNumber)
            });
        };
        _this.savePhoneNumberChanges = function (event) {
            event.preventDefault();
            var phoneNumber = _this.state.phoneNumber;
            _this.props.onStateChange("policyHolder.phoneNumber", phoneNumber);
            _this.toggleModal();
            _this.executeEvent("change");
            _this.navigateToNextPage();
        };
        _this.navigateToPage = _this.getSetting("navigateToPage", undefined);
        var journeyState = _this.props.engine.getJourneyState();
        _this.state = {
            showPopup: journeyState["showPhoneNumberPopup"] || false,
            phoneNumberValidated: false,
            phoneNumber: _this.props.interaction.policyHolder.phoneNumber ? _this.props.interaction.policyHolder.phoneNumber : '00000000000'
        };
        _this.props.engine.setJourneyState((_a = {},
            _a["showPhoneNumberPopup"] = _this.state.showPopup,
            _a));
        _this.toggleModal = _this.toggleModal.bind(_this);
        return _this;
    }
    EditPhoneNumberPopupWidget.prototype.renderInputField = function () {
        var journeyState = this.props.engine.getJourneyState();
        return journeyState["showPhoneNumberPopup"] && this.renderPopup();
    };
    EditPhoneNumberPopupWidget.prototype.toggleModal = function () {
        var _this = this;
        this.setState({ showPopup: false }, function () {
            var _a;
            _this.props.engine.setJourneyState((_a = {}, _a["showPhoneNumberPopup"] = _this.state.showPopup, _a));
        });
    };
    EditPhoneNumberPopupWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "navigateToPage", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], EditPhoneNumberPopupWidget);
    return EditPhoneNumberPopupWidget;
}(plugin_journey_1.QuestionWidgetBase));
//# sourceMappingURL=EditPhoneNumberPopupWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/EditPhoneNumberPopupWidget.js
// module id = 3185
// module chunks = 0